/** Etykiety UI → kody województw w API RSPO (RspoScopeFilter::VOIVODESHIP_CODES). */
export const RSPO_VOIVODESHIPS = [
	{ label: 'dolnośląskie', code: 'DOLNOŚLĄSKIE' },
	{ label: 'kujawsko-pomorskie', code: 'KUJAWSKO-POMORSKIE' },
	{ label: 'lubelskie', code: 'LUBELSKIE' },
	{ label: 'lubuskie', code: 'LUBUSKIE' },
	{ label: 'łódzkie', code: 'ŁÓDZKIE' },
	{ label: 'małopolskie', code: 'MAŁOPOLSKIE' },
	{ label: 'mazowieckie', code: 'MAZOWIECKIE' },
	{ label: 'opolskie', code: 'OPOLSKIE' },
	{ label: 'podkarpackie', code: 'PODKARPACKIE' },
	{ label: 'podlaskie', code: 'PODLASKIE' },
	{ label: 'pomorskie', code: 'POMORSKIE' },
	{ label: 'śląskie', code: 'ŚLĄSKIE' },
	{ label: 'świętokrzyskie', code: 'ŚWIĘTOKRZYSKIE' },
	{ label: 'warmińsko-mazurskie', code: 'WARMIŃSKO-MAZURSKIE' },
	{ label: 'wielkopolskie', code: 'WIELKOPOLSKIE' },
	{ label: 'zachodniopomorskie', code: 'ZACHODNIOPOMORSKIE' },
] as const;
